import { get } from 'lodash';
import { RootState } from 'store';
import { useAppSelector } from 'store/hooks';
import { IDEMOModelResDataItem } from '../interfaces/demoData';
import { IApiGetListScreensInStoreParam, IApiGetListStoresParam, IDetailStore, IStore, ITimezone } from '../interfaces/api';
import { PaginationResponse } from 'services/commonTypes';
import { IScreen } from 'modules/dashboard/interfaces/api';
import { IPlaylist } from 'modules/playlist/interfaces/api';
import { IListLibraryMediaResponse, ISummaryStore } from 'modules/media/interfaces/api';
/**
 * please change reducer name
 */
// @ts-ignore
type MyState = RootState['store']; // ex: RootState['booking']
// @ts-ignore
const getCurrentState = (state: RootState): MyState => state['store']; // ex: state['booking']

const selector = <T = MyState>(key: keyof T, defaultValue?: any) => useAppSelector(state => get(getCurrentState(state), key, defaultValue));

const getDemoData = () => selector('demoData') as IDEMOModelResDataItem[];
const getDataStores = () => selector('dataStores') as PaginationResponse<IStore>;
const getStoreListParams = () => selector('storeListParams') as IApiGetListStoresParam;
const getScreenListInStore = () => selector('screenListInStore') as PaginationResponse<IScreen>;
const getTimezones = () => selector('timezones') as ITimezone[];
const getAllStores = () => selector('allStores') as PaginationResponse<IStore>;
const getDetailStore = () => selector('detailStore') as IDetailStore;
const getPlaylistsInStore = () => selector('playlistsInStore') as PaginationResponse<IPlaylist>;
const getAllPlaylistsInStore = () => selector('allPlaylistsInStore') as PaginationResponse<IPlaylist>;
const getPlaylistsInStoreParam = () => selector('playlistsInStoreParam') as IApiGetListStoresParam; 
const getMediaInStore = () => selector('mediaInStore') as IListLibraryMediaResponse;
const getSummaryStore = () => selector('summaryStore') as ISummaryStore;
const getScreenListInStoreParam = () => selector('screenListInStoreParam') as IApiGetListScreensInStoreParam;

const storeSelectors = {
  getDemoData,
  getDataStores,
  getStoreListParams,
  getScreenListInStore,
  getTimezones,
  getAllStores,
  getDetailStore,
  getPlaylistsInStore,
  getAllPlaylistsInStore,
  getPlaylistsInStoreParam,
  getMediaInStore,
  getSummaryStore,
  getScreenListInStoreParam,
};
export default storeSelectors;
